<div class="content-wrapper-inner relative">
  <app-disabled-section-widget [service]="'sip'" (changeState)="testingDisabledSip = !$event.service"></app-disabled-section-widget>
  <app-disabled-section-widget [service]="'voice'" (changeState)="testingDisabledVoice = !$event.service"></app-disabled-section-widget>
  <div *ngIf="testingDisabledVoice === false && testingDisabledSip === false">
    <div class="create-test-section border">
      <app-sip-form (onAfterSave)="afterSaveTestCase()" [pauseUpdate]="pauseUpdateForm"></app-sip-form>
    </div>
    <app-sip-search-form (onSubmit)="onSubmitFilter($event)"></app-sip-search-form>
    <div class="dataTables_wrapper form-inline dt-bootstrap pos-relative">
      <app-sip-results-table (changeBatch)="selectedRows.set($event)"></app-sip-results-table>
      <div class="table-action-info-bar" *ngIf="selectedRows().length">
        <div class="info-left">
          <div class="text-icon-holder" tabindex="0" (keyup.enter)="batchClear()" (click)="batchClear()">
            <span class="icon">
              <span class="selected icon-done"></span>
            </span>
            <span class="text">{{ selectedRows().length }} Selected</span>
          </div>
        </div>
        <div class="info-right">
          <button [disabled]="!hasReimbursableTests()" class="btn ghost-btn btn-action text-icon-holder" (click)="onBatchReimburse()" *ngIf="isAdmin">
            <span class="icon">
              <span class="far fa-money-bill-alt fs-4"></span>
            </span>
            <span class="text ms-0_5">Reimburse</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #reimburseModalTpl let-dialogRef="dialogRef">
  <confirm-modal [dialogRef]="dialogRef"></confirm-modal>
</ng-template>
